import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: [
    '../../app.component.css',
    './contacto.component.css']
})
export class ContactoComponent implements OnInit {

  jumbotronTitle = 'Contacto';

  constructor(  ) { }

  ngOnInit(): void {
  }

}
